import { useMemo } from 'react';
import { Button } from 'react-bootstrap';

import { BootstrapTable } from '@components/Table/Table';

const renderPDFButtonCell = ({ value }) => (
  <Button variant="didxl" as="a" href={value} size="sm" target="_blank">
    PDF
  </Button>
);

export const TermsAndConditionsTable = ({ data }) => {
  const columns = useMemo(
    () => [
      {
        Header: 'Document',
        accessor: 'description',
      },
      {
        Header: 'Download',
        accessor: 'pdf_location',
        Cell: renderPDFButtonCell,
      },
    ],
    []
  );
  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({ responsive: true, borderless: true })}
    />
  );
};
